module.exports = __webpack_public_path__ + "assets/5f987aeb89d0a8f06cb0a6cc4e3d3a99.svg";